import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  overlay?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message,
  overlay = false,
}) => {
  const content = (
    <div className="spinner-container">
      <div className={`loading-spinner spinner-${size}`} />
      {message && <p className="spinner-message">{message}</p>}
    </div>
  );

  if (overlay) {
    return <div className="spinner-overlay">{content}</div>;
  }

  return content;
};

export default LoadingSpinner;